import type { NavigateFunction } from '@suntex.core/nav';
import type { Entities_Login_StateInfo_Response } from '@suntex.fim/api-client';
import { EntityLevel, LoginType } from '@suntex.fim/enums';

import { entityPath } from '../utils/paths';

type HomeUser = Pick<
  Entities_Login_StateInfo_Response,
  'entityId' | 'schoolId' | 'districtId' | 'regionId' | 'loginType'
>;

/** Return the home route matching the user's login type. */
export function getHomePath(user: HomeUser): string {
  const routes: Partial<Record<LoginType, string>> = {
    [LoginType.NotLoggedIn]: '/login',
    [LoginType.IndividualPlayer]: entityPath(
      EntityLevel.Player,
      user.entityId,
      'dashboard',
    ),
    [LoginType.StudentPlayer]: entityPath(
      EntityLevel.Player,
      user.entityId,
      'dashboard',
    ),
    [LoginType.TeamLeader]: entityPath(
      EntityLevel.Team,
      user.entityId,
      'dashboard',
    ),
    [LoginType.SchoolPrincipal]: entityPath(
      EntityLevel.School,
      user.schoolId,
      'dashboard',
    ),
    [LoginType.DistrictAdmin]: entityPath(
      EntityLevel.District,
      user.districtId,
      'dashboard',
    ),
    [LoginType.RegionAdmin]: entityPath(
      EntityLevel.Region,
      user.regionId,
      'dashboard',
    ),
    [LoginType.SalesRep]: '/sales/dashboard',
    [LoginType.Multi]: '/multi/dashboard',
    [LoginType.LimitedAdmin]: '/admin/dashboard',
    [LoginType.Admin]: '/admin',
  };
  return routes[user.loginType] ?? '/not-authorized';
}

/**
 * Redirect a freshly authenticated user to the dashboard that matches their
 * login type.
 */
export function handleNavigation(
  user: HomeUser,
  navigate: NavigateFunction,
): void {
  const route = getHomePath(user);
  const currentPath = window.location.pathname;

  if (currentPath === route || currentPath === '/*') {
    return;
  }
  navigate(route, { replace: true });
}
